import { AuthState, OktaAuth } from '@okta/okta-auth-js'
import { clearLocalStorage } from '@contexts/helpers'
import { SegmentPage, SegmentTrack } from '@enums/segment'
import { segmentTrack } from '../segment/track/track'

/**
 * @param authState {AuthState}
 */
export const signOut = async (authState: AuthState) => {
  if (window.Cypress) {
    clearLocalStorage()
    // mocking the Hub sign-out event triggering a local storage clear for the integration test
    return
  }

  // logout from okta
  const { idToken } = authState
  const oktaClient = new OktaAuth(idToken)
  oktaClient.signOut({
    postLogoutRedirectUri: `${window.location.origin}/logout`,
    idToken: idToken,
  })

  oktaClient.tokenManager.clear()
  clearLocalStorage()
  segmentTrack(SegmentTrack.signOut, {
    page_name: SegmentPage.app,
    forced: true,
  })
}
